/** @format */

import {Box, Typography} from '@mui/material';

import {useTheme} from '@mui/material/styles';

import {WIDGETS_LIST} from 'pages/Home/DigitalCast/constants/widgets';
import getCategoryIcon from 'pages/Home/DigitalCast/helpers/getCategoryIcon';
import getWidgetIcon from 'pages/Home/DigitalCast/helpers/getWidgetIcon';
import isStubChartId from 'pages/Home/DigitalCast/helpers/isStubChartId';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';
import {SubMenu, WidgetBlockId} from 'pages/Home/DigitalCast/models/widgets';

import {ButtonsBox} from '../../style';
import CheckboxRow from '../checkbox-row';
import DropdownButton from '../dropdown-button';
import {BlockRoot as Root, blockClasses as classes} from './style';

interface Props {
  commonWidgets: ChartIds[];
  subMenu?: SubMenu;
  label?: string;
  blockId: WidgetBlockId;
  onClickAdd?: () => void;
  onChangeSelection: (chartId: ChartIds) => void;
  onRemove: (chartId: ChartIds) => void;
  space: Space;
  onAddCrWidget?: () => Space | void;
  onConfirmMenuSettings?: (space?: Space) => void;
}

const WidgetsBlock = ({
  commonWidgets,
  subMenu,
  label,
  blockId,
  space,
  onClickAdd,
  onChangeSelection,
  onRemove,
  onConfirmMenuSettings,
  onAddCrWidget,
}: Props) => {
  const showIconAndLabel = Boolean(label);
  const hasSubMenu = Boolean(subMenu && onClickAdd);

  const theme = useTheme();

  const handleDropdownButtonClick = () => {
    if (blockId === 'funnel') {
      const updatedSpace = onAddCrWidget?.();
      onConfirmMenuSettings?.(updatedSpace || undefined);
      return;
    }

    onClickAdd?.();
  };

  const customizableWidgets =
    subMenu?.widgets.filter(id => space.widgetsMenuSelected.includes(id)) || [];

  const getLabel = (id: ChartIds): string => {
    if (id.startsWith('funnel_cr_')) {
      const custom = space.widgetsSettings[id]?.custom;

      return custom?.label || WIDGETS_LIST[id].label;
    }
    return WIDGETS_LIST[id].label;
  };

  return (
    <Root data-testid={`dropdown-block-${blockId}`}>
      {showIconAndLabel && (
        <Box className={classes.labelBox}>
          <Typography className={classes.label}>{label}</Typography>
          {getWidgetIcon(blockId, theme.palette.figma_gray_dark_5?.main)}
        </Box>
      )}
      {commonWidgets.map(chartId => (
        <CheckboxRow
          key={chartId}
          checked={space.widgetsBoardSelected.includes(chartId)}
          label={getLabel(chartId)}
          onChange={() => onChangeSelection(chartId)}
          isStub={isStubChartId(chartId)}
          categoryIcon={getCategoryIcon(chartId)}
        />
      ))}
      {customizableWidgets.map(chartId => (
        <CheckboxRow
          key={chartId}
          checked={space.widgetsBoardSelected.includes(chartId)}
          label={getLabel(chartId)}
          onChange={() => onChangeSelection(chartId)}
          onRemove={() => onRemove(chartId)}
          isStub={isStubChartId(chartId)}
          categoryIcon={getCategoryIcon(chartId)}
        />
      ))}
      {hasSubMenu && (
        <ButtonsBox>
          <DropdownButton variant='secondary' onClick={handleDropdownButtonClick}>
            {subMenu!.addButtonText}
          </DropdownButton>
        </ButtonsBox>
      )}
    </Root>
  );
};

export default WidgetsBlock;
